import Section, { SectionDTO } from '../Section';

export const convertFromSectionDTO = (dto: SectionDTO): Section => dto;
